(ns app.db  (:require [datascript.core :as datascript]
                      [re-posh.core :as re-posh]))

(def default-db
  {})

(def default-ds
  [{:db/id 1
    :app/type :type/selected-workspace}
   {:db/id 2
    :app/type :type/workspaces}
   {:db/id 3
    :app/type :type/selected-folder}
   {:db/id 4
    :app/type :type/folders}
   {:db/id 5
    :app/type :type/user}
   {:db/id 6
    :app/type :type/error
    :error/show false}
   {:db/id 7
    :app/type :type/last-action}
   {:db/id 8
    :app/type :type/deleted-selected-workspace}
   {:db/id 9
    :app/type :type/statistics}
   {:db/id 12
    :app/type :type/deleted-selected-folder}
   {:db/id 13
    :app/type :type/folder-status}
   {:db/id 14
    :app/type :type/restored-folder}
   {:db/id 15
    :app/type :type/form-filling}])
